const SectionTitle = () => import("@/components/SectionTitle/SectionTitle.vue");
import fallbackToAvatar from "@/mixins/fallbackToAvatar";
import { mapGetters } from "vuex";
import agencyService from '@/services/agency';
import Utils from "@/mixins/Utils";

export default {
  components: {
    SectionTitle,
  },
  mixins: [fallbackToAvatar, Utils],
  data() {
    return {
      cdcs: {},
    };
  },
  computed: {
    ...mapGetters({
      loading: 'isLoading',
      errorMessage: 'errorMessage'
    })
  },
  created() {
    this.loadCDC();
  },
  methods: {
    loadCDC() {
      const vue = this;
      agencyService.getAgence().then(res => {
        if (res.success) {
          vue.cdcs = res.data.cdcs;
        }
      }).catch(err => {
        vue.callToaster(vue.$t('problem-arise'));
      })
    },
  },
};
